/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Askquestion_Description2Inputs */

const en_coinvestments_messages_askquestion_description2 = /** @type {(inputs: Coinvestments_Messages_Askquestion_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a message to the team. They'll get back to you as soon as possible.`)
};

/**
* | output |
* | --- |
* | "Send a message to the team. They'll get back to you as soon as possible." |
*
* @param {Coinvestments_Messages_Askquestion_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_askquestion_description2 = /** @type {((inputs?: Coinvestments_Messages_Askquestion_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Askquestion_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_askquestion_description2(inputs)
});
export { coinvestments_messages_askquestion_description2 as "coInvestments_messages_askQuestion_description" }